/* cspell:disable-next-line */
const env = import.meta.env ?? {}   // fallback for e2e tests.

export const OktaClientId = env['VITE_OKTA_CLIENT_ID']
export const ENV = (env['VITE_ENV'] ?? 'dev') as string // `as string` here to prevent TS to think this has just one value
export const GCS_ENV_NAME = env['VITE_GCS_ENV_NAME'] ?? 'dev' // This value will be deprecated when the center app will work just with oversight
export const CENTER_NAME = env['VITE_GCS_CENTER_NAME'] ?? GCS_ENV_NAME
export const SUBDOMAIN_SUFFIX = env['VITE_SUBDOMAIN_SUFFIX'] ?? '' // Shouldn't be used locally
export const OVERSIGHT_ENV_NAME = env['VITE_OVERSIGHT_ENV_NAME'] ?? 'localhost'
export const DEFAULT_CONTROL_MODE = env['VITE_DEFAULT_CONTROL_MODE'] ?? 'legacy_control'
export const SHOW_CONTROL_MODE_TOGGLE = ((env['VITE_SHOW_CONTROL_MODE_TOGGLE'] ?? 'true')?.toUpperCase()) === 'TRUE'
